const BASE_URL = "https://api.kutchibrahmakshatriya.com/";
const AUTH_HEADER = "X-SKBP-Token-Id";
const SESSION_STORAGE_TOKEN = "token";
const SESSION_STORAGE_AUTH_FLAG = "isAuthenticated";
const AES_SECRET_KEY = "key$aapno#parichay*13579";
const CACHE_ROUTE = "cache_route";

export {
  AUTH_HEADER,
  BASE_URL,
  SESSION_STORAGE_AUTH_FLAG,
  SESSION_STORAGE_TOKEN,
  AES_SECRET_KEY,
  CACHE_ROUTE,
};
